import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { CONFIG } from 'src/helper/app-config';
import { MsalService } from '@azure/msal-angular';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { UserSupportPopUpComponent } from '../user-support-pop-up/user-support-pop-up.component';

@Component({
  selector: 'app-nav-component',
  templateUrl: './nav-component.component.html',
  styleUrls: ['./nav-component.component.css'],
})
export class NavComponentComponent implements OnInit, OnDestroy {
  @Output() logoutEventEmitter = new EventEmitter();

  CONFIG = CONFIG;
  tabs = [{ name: 'Planograms', pathname: CONFIG.PATH.PLANOGRAMS }];
  isShow: boolean = true;
  isAdmin:boolean=false;
  active_tab = this.tabs[0].name;

  private subscriptions: Subscription = new Subscription();

  constructor(
    private authService: MsalService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog:MatDialog
  ) {
    this.activatedRoute.params.subscribe((params) => {
      const router_state =
        this.router.getCurrentNavigation()?.extras?.state?.['screen'] || '';
    });
  }

  ngOnInit(): void {
    this.isShow = true;
    this.setupRouterEventListeners();
    this.checkRouterState();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private setupRouterEventListeners(): void {
    const routerEventsSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.checkRouterState();
      });
    const activatedRouteParamsSubscription =
      this.activatedRoute.params.subscribe(() => {
        this.checkRouterState();
      });

    const activatedRouteQueryParamsSubscription =
      this.activatedRoute.queryParams.subscribe(() => {
        this.checkRouterState();
      });

    const routeDataSubscription = this.activatedRoute.data.subscribe(() => {
      this.checkRouterState();
    });

    this.subscriptions.add(routerEventsSubscription);
    this.subscriptions.add(activatedRouteParamsSubscription);
    this.subscriptions.add(activatedRouteQueryParamsSubscription);
    this.subscriptions.add(routeDataSubscription);

    this.checkRouterState();
  }

  private checkRouterState(): void {
    const routerState =
      this.router.getCurrentNavigation()?.extras.state ||
      this.activatedRoute.snapshot.queryParams;
    this.activatedRoute.url.subscribe((segments) => {
      segments.map((segment) => {
        if (segment.path === '') {
          // this.isShow = true;
        }
      });
    });
   
    if (window.location.pathname !== '/planogram/planograms') {
      this.isShow = false;
    }
    if (window.location.pathname == '/admin-user-analytics') {
      this.isShow = true;
      this.isAdmin=true
    }
    if (window.location.pathname == '/admin-update-guidelines') {
      this.isShow = true;
      this.isAdmin=true
    }
    if (window.location.pathname == '/admin-data-update') {
      this.isShow = true;
      this.isAdmin=true
    }
    if (Object.keys(routerState).length !== 0) {
      if (routerState['screen_index'] !== 0) {
        this.isShow = false;
      }
      if (routerState['screen'] === 'planogram-list') {
        this.isShow = true;
      }
    }
  }

  handleActiveTab(name: string): void {
    this.active_tab = name;
  }

  handleRedirect(): void {
    this.router.navigate([CONFIG.LANDINGPAGEPATH]);
  }

  logout(): void {
    this.authService.logout();
  }


  openUserSupportDialog(){
    this.dialog.open(UserSupportPopUpComponent, {
      height: '70vh',
      width: '55vw',
      maxWidth:'55vw',
      data: {},
    });
  }
}
